<template>
  <div>
    <div v-if="loading" class="center">
      <md-progress-spinner
        :md-diameter="100"
        :md-stroke="10"
        md-mode="indeterminate"
      />
    </div>
    <form v-if="!loading" @submit.prevent="handleSubmit">
      <LocalCampos
        ref="local"
        :nome="local.nome"
        :descricao="local.descricao"
        :time-zone="local.timeZone"
        :read-only="readOnly"
      />
      <br />
      <Endereco
        ref="endereco"
        :read-only="readOnly"
        :complemento="local.complemento"
        :logradouro="local.logradouro"
        :bairro="local.bairro"
        :cep="local.cep"
        :cidade="local.cidade"
        :numero="local.numero"
      />
      <br />
      <div v-if="!readOnly" style="text-align: right">
        <md-button :to="{ name: 'LocalIndex' }" class="md-accent">
          Voltar
        </md-button>
        <md-button type="submit" class="md-raised md-primary">
          Salvar
        </md-button>
      </div>
      <br />
    </form>
    <md-progress-bar v-if="enviando" md-mode="indeterminate" />
  </div>
</template>

<script>
import Endereco from '../../components/Endereco'
import LocalCampos from '../../components/local/LocalCampos'
import http from '../../utils/http'

export default {
  name: 'LocalEditar',
  components: { LocalCampos, Endereco },
  props: {
    readOnly: Boolean,
  },
  data() {
    return {
      local: {},
      enviando: false,
      loading: true,
    }
  },
  async mounted() {
    const id = this.localId || this.$route.params.localId
    this.local = (await http.get(`local/${id}`)).local

    this.loading = false
  },
  methods: {
    async handleSubmit() {
      const endereco = this.$refs.endereco.returnData()
      const local = this.$refs.local.returnData()

      const validacao = endereco.validation && local.validation

      if (!validacao) {
        return
      }
      this.enviando = true

      const response = await http.put('local', {
        id: this.local.id,
        ...local.data,
        endereco: {
          ...endereco.data,
          cidadeId: endereco.data.cidadeId,
        },
      })

      if (response) {
        const back =
          (this.$router.params && this.$router.params.routeBack) || 'LocalIndex'
        await this.$router.push({ name: back || 'LocalIndex' })
      }
      this.enviando = false
    },
  },
}
</script>

<style lang="scss" scoped>
.left-zero {
  padding-left: 0;
  margin-left: 0;
  margin-right: 5% !important;
}

.center {
  text-align: center;
  padding-top: 30vh;
}
</style>
